import {buildBitsetText} from './buildBitsetText';

/**
 * Generiert den automatisch zusammengesetzten Teil des Tooltips,
 * analog zu den C++-Definitionen (z.B. c_strItemNameDeco, c_strLineFeed, c_strLineGap etc.)
 */
function generateAutoTooltip(item) {
  // Wir bauen den Tooltip ähnlich wie in der C++-Funktion auf.
  // Dabei kommen beispielsweise folgende Bestandteile zum Einsatz:
  // - Itemnamen-Dekoration
  // - Basis-/Opt-Werte (Platzhalter für den Bitset-HTML)
  // - Limit-Level und Gewicht
  // Anpassungen (wie <size:...> Tags) können später durch weitere Ersetzungen umgesetzt werden.
  return (
    '<b><size:13>#@itemname@#</b><br>' +
    '<size:4><br><size:10>' +
    'Lv: #@use_level@#<br>' +
    '<size:4><br><size:10>' +
    'Limit Lv: #@limit_level@#<br>' +
    '<size:4><br><size:10>' +
    '#@bitset_text@#<br>' +
    '<size:4><br><size:10>'
  );
}

export function processTooltip(item) {
  let tooltip = item.item_description || '';
  const resource = item.resource || item || {};
  let itemName = item.item_name || 'Unknown Item';

  const enhanceLevel = parseInt(resource.enhance, 10) || 0;
  const itemLevel = parseInt(resource.level, 10) || 0;

  if (itemLevel > 0) {
    // Prefix Lv nach den Itemnamen setzen
    itemName = `${itemName} Lv${resource.level}`;
  }

  if (enhanceLevel > 0) {
    // Prefix +X vor den Itemnamen setzen
    itemName = `+${enhanceLevel} ${itemName}`;
  }

  // Prüfe, ob der Tooltip ausschließlich den Auto-Marker enthält
  const trimmedTooltip = tooltip.trim();
  const isOnlyAuto =
    trimmedTooltip === '@#auto_tooltip#@' || trimmedTooltip === '@#auto_tooltip#@<br>' || trimmedTooltip === '';

  // Falls nur der Marker (ohne zusätzlichen Text) vorhanden ist, ersetzen wir ihn komplett
  if (isOnlyAuto) {
    tooltip = generateAutoTooltip(item);
  } else if (tooltip.includes('@#auto_tooltip#@')) {
    // Falls der Marker im Text vorkommt und noch zusätzlicher Text vorhanden ist,
    // ersetzen wir ihn durch den automatisch generierten Tooltip-Teil.
    tooltip = tooltip.replace(/@#auto_tooltip#@/g, generateAutoTooltip(item));
  }
  // Falls kein Marker vorhanden ist, bleibt tooltip unverändert.

  // Nun ersetzen wir die restlichen Platzhalter:

  // (a) Itemname
  tooltip = tooltip.replace(/#@itemname@#/g, `${itemName}<br>`);

  // (b) Base-/Opt-Werte: Bitset-HTML
  const bitsetHtml = buildBitsetText(resource);
  if (bitsetHtml) {
    tooltip = tooltip.replace(/#@bitset_text@#/g, `<hr>${bitsetHtml}`);
  } else {
    tooltip = tooltip.replace(/#@bitset_text@#/g, '');
  }

  // (c) Limit-Level
  if (resource.use_min_level != null) {
    let lvl = parseInt(resource.use_min_level, 10);
    if (lvl < 1) lvl = 1;
    tooltip = tooltip.replace(/#@use_level@#/g, lvl.toString());
  } else {
    tooltip = tooltip.replace(/#@use_level@#/g, '');
  }

  // (c) Limit-Level
  if (resource.use_max_level != null) {
    let lvl = parseInt(resource.use_max_level, 10);
    if (lvl < 1) lvl = 300; // Wie in der C++-Logik
    tooltip = tooltip.replace(/#@limit_level@#/g, lvl.toString());
  } else {
    tooltip = tooltip.replace(/#@limit_level@#/g, '');
  }

  // Entferne sonstige Platzhalter (z.B. #@job_depth@#)
  tooltip = tooltip.replace(/#@job_depth@#/g, '');

  // <size:X> in <span style="font-size:Y.rem"> umwandeln
  tooltip = tooltip.replace(/<size:([0-9]+)>/gi, (match, fontSize) => {
    const sizeValue = parseInt(fontSize, 10) || 10;
    const scaled = (sizeValue / 12).toFixed(1);
    return `<span style="font-size:${scaled}rem">`;
  });

  // Überflüssige <br>-Tags entfernen, wenn sie direkt aufeinander folgen
  tooltip = tooltip.replace(/(>)<br\s*\/?>(<)/g, '$1$2');

  // Entferne sonstige Platzhalter in spitzen Klammern (z.B. <#irgendwas>)
  tooltip = tooltip.replace(/<#[^>]*>/g, '');

  // Socket-Icons am Ende hinzufügen
  let socketIconsHtml = '';
  for (let i = 0; i < 4; i++) {
    const socketKey = `socket_${i}_icon`;
    const iconName = resource[socketKey];
    if (iconName && iconName.trim() !== '') {
      socketIconsHtml += `<img src="/assets/items/${iconName}.jpg" alt="Socket ${i}" style="width:20px; height:20px;">`;
    } else {
      // Leerer Platzhalter, damit die Zelle auch belegt wird (optional)
      socketIconsHtml += `<div style="width:20px; height:20px;"></div>`;
    }
  }
  if (socketIconsHtml !== '') {
    tooltip += `<div style="display: grid; grid-template-columns: repeat(4, 20px); gap:2px; margin-top:5px;">${socketIconsHtml}</div>`;
  }

  // Tooltip ggf. kürzen
  if (tooltip.length > 1800) {
    tooltip = tooltip.substring(0, 1800) + '...<br><br>(more info InGame)';
  }

  return tooltip;
}
